import { ROLES } from '~/utils/role-utils'
import { type User } from '~/utils/types/user'

const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '[::1]'])

export function canImpersonateUser(
  user: Pick<User, 'role'> | null,
  hostname: string,
): boolean {
  if (!LOCAL_HOSTNAMES.has(hostname)) return false

  return user?.role === ROLES.ADMIN || user?.role === ROLES.PS_TEAM
}
